export default {"src":"/_next/static/media/your-next-chapter-image.8a178e24.svg","height":533,"width":386,"blurWidth":0,"blurHeight":0};